import { createContext, useContext } from 'react'

export const DialogContext = createContext<{
  isOpened: boolean
  isPending: boolean
  isDoNotClose: boolean
  doNotClose: (isDoNotClose: boolean) => void
  pending: (isPending: boolean) => void
  close: () => void
  anywayClose: () => void
}>({
  isOpened: false,
  isPending: false,
  isDoNotClose: false,
  doNotClose: () => null,
  pending: () => null,
  close: () => null,
  anywayClose: () => null
})

export const useDialog = () => useContext(DialogContext)
